import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { StyledModal,CalendarHeader,Border, ConfirmPlanModalBody, Badge, GridItem, PointsGrid, LevelIconContainer } from './styles';
import { withRouter } from 'react-router-dom';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import { CommonButtonBorder } from '../../common/commonStyles';
import LazyImage from '../../common/LazyImage/LazyImage';
import { ImageUrl } from '../../../utils/constants';
import { TIER_ICONS } from './TiersModal';
import { capitalizeText, fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import { PostCompanyAdminRewardTierConfig } from '../../../redux/constants/apiConstants';


const ConfirmPlanModal = ({
  show,
  icon,
  title,
  onCancel,
  modalWidth = "500px",
  modalHeight,
  //   onClose,
  selectedStartMonth,
  selectedEndMonth,
  selectedPlan,
  points,
  companyInfo,
  screen,
  history,
  fetchCompanyRewardsDetailsYearwise,
  editData
  //   tierConfig,
}) =>{

  const [loading, setLoading] = useState(false);


  const postCompanyRewardTier = async() =>{
    setLoading(true);
    const{Bronze,Gold,Silver,Platinum} = points
    const payload = {company_id:companyInfo.id, bronze_badge:Number(Bronze), silver_badge:Number(Silver), gold_badge:Number(Gold),platinum_badge:Number(Platinum),reward_start_date:selectedStartMonth.firstDate,reward_end_date:selectedEndMonth.firstDate}

    if(editData){
      payload.reward_period_id=editData.id
    }

    try {
      const companyRewardsData = await fetchApi(PostCompanyAdminRewardTierConfig , editData ? "PUT" : "POST",payload);
      if(companyRewardsData?.status === 'success'){
        if(screen === 'custom'){
          history.push("/company/admin-rewards-management/dashboard");
        }else if(screen === 'rewards'){
          fetchCompanyRewardsDetailsYearwise()
        }
        onCancel();
      }else{
        toast.error(companyRewardsData?.data?.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }



  const SelectPointTierLevels = () => {
    window.console.log("hihi");
    
    return (
      <>
        <Badge bg={selectedPlan?.tierBg} className='plan-badge'>{selectedPlan?.badge}</Badge>
        <LazyImage src={ImageUrl + '/images/admin-rewards/admin-reward-plan.svg'}/>
        <div className='date-heading'>Rewards Set From</div>
        <div className='date'>{selectedStartMonth?.month} - {selectedEndMonth?.month}</div>
        <div className='sub-heading'>{selectedPlan?.description}</div>

        <PointsGrid>
          {Object.entries(points).map(([level, value]) => {
            const LevelIconDetails = TIER_ICONS[capitalizeText(level)];
        
            return (
              <GridItem key={level}>
                <LevelIconContainer
                  bg={LevelIconDetails?.bg}
                  border={LevelIconDetails?.border}
                >
                  <LazyImage
                    div={'image'}
                    src={ImageUrl + LevelIconDetails.src}
                  />
                </LevelIconContainer>
        
                <span>
                  <span className="level">{level}</span> –{" "}
                  {value.toLocaleString()} Points
                </span>
              </GridItem>
            );
          })}
        </PointsGrid>

        
      </>
    );
  };
      
    
  return(
    <StyledModal show={show} width={modalWidth} height={modalHeight}>
      <div className="modal-content-padding">
        <CalendarHeader>
          <div className="left-content">
            <div className="icon">{icon && icon}</div>
            <div>{title}</div>
          </div>
          {/* <div className="close-icon" onClick={()=>onClose ? onClose() :onCancel()}>
            {AdminCloseIcon()}
          </div> */}
        </CalendarHeader>
        <Border/>
  
      </div>

      <ConfirmPlanModalBody>

        {SelectPointTierLevels()}
      </ConfirmPlanModalBody>

      <Border/>
  
      <div className='footer'>
        <CommonButtonBorder height="48px" width="200px" margin="0px 16px 0px 0px" disabled={!selectedStartMonth || !selectedEndMonth} onClick={() => onCancel()}>
          Back
        </CommonButtonBorder>
        <CommonButtonPopup height="48px" width="200px" disabled={!selectedStartMonth || !selectedEndMonth || loading} onClick={() => postCompanyRewardTier()}>
          Confirm
        </CommonButtonPopup>
  
      </div>
    </StyledModal>
  )};


ConfirmPlanModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title:PropTypes.string, 
  onCancel: PropTypes.func.isRequired,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  icon: PropTypes.node.isRequired, 
  onClose:PropTypes.func,
  history:PropTypes.object,
  tierConfig:PropTypes.string,
  companyInfo:PropTypes.object,
  selectedStartMonth:PropTypes.object,
  selectedEndMonth:PropTypes.object,
  onMonthChange:PropTypes.func,
  selectedPlan:PropTypes.string,
  points:PropTypes.object,
  screen:PropTypes.string,
  fetchCompanyRewardsDetailsYearwise:PropTypes.func,
  editData:PropTypes.object
};

export default withRouter((ConfirmPlanModal));
  
